import { ReviewPromptPlatform } from '@shared/core/billing'
import { BookingOnboardingDto } from '@shared/core/booking-onboarding'
import type { AtRiskAppointments, ListEventsResponseEntry } from '@shared/core/events'
import { UserEventType } from '@shared/core/user-events'
import { GetProfileResponseDto } from '@shared/core/users'
import { ALERT_CAMPAIGN_IDS } from './alerts.constants'

export type AlertCampaignId = (typeof ALERT_CAMPAIGN_IDS)[keyof typeof ALERT_CAMPAIGN_IDS]

export type G2CapterraReviewAlertState = {
  isG2PromptCapReached: boolean
  reviewPlatform: ReviewPromptPlatform | null
  isG2CapacityLoading: boolean
}

export const DEFAULT_G2_CAPTERRA_REVIEW_ALERT_STATE: G2CapterraReviewAlertState = {
  isG2PromptCapReached: true,
  reviewPlatform: null,
  isG2CapacityLoading: false,
}

export type SetAndForgetPromoAlertState = {
  manualConsentActivationCount: number
  autoActivateWhenClear: boolean
}

export const DEFAULT_SET_AND_FORGET_PROMO_ALERT_STATE: SetAndForgetPromoAlertState = {
  manualConsentActivationCount: 0,
  autoActivateWhenClear: false,
}

export type PausedRemindersAlertState = {
  /** True once both the not-sent count and the visible-range events settled, failures included. */
  isReady: boolean
  notSentCount: number
  atRisk: AtRiskAppointments<ListEventsResponseEntry>
}

export const DEFAULT_PAUSED_REMINDERS_ALERT_STATE: PausedRemindersAlertState = {
  isReady: false,
  notSentCount: 0,
  atRisk: { count: 0, next: null, rows: [] },
}

export type AlertContext = {
  profile: GetProfileResponseDto | null
  bookingOnboarding: BookingOnboardingDto | null
  activeEventsCount: number
  userEvents: Set<UserEventType>
  g2CapterraReview: G2CapterraReviewAlertState
  setAndForgetPromo: SetAndForgetPromoAlertState
  pausedReminders: PausedRemindersAlertState
}

export type AlertCampaign = {
  id: AlertCampaignId
  priority: number
  seenEventName: UserEventType
  isEligible: (context: AlertContext) => boolean
}
